import { useState } from 'react'

import Calendar from '~/components/Calendar/Calendar/Calendar'
import { Appointment } from '~/types/tutoring-api'
import { getBrowserTimezone } from '~/utils/helpers'

import Appointments from './Appointments/Appointments'
import { Ordering } from './Appointments/Appointments.types'
import { getAppointmentsForDate, getAppointmentsFromDate, getDatesWithAppointments } from './PanelSchedule.utils'

export default function PanelSchedule({
  appointments = [],
  appointmentsOrdering,
  date,
  isTutor = false,
  onDateClick,
}: {
  appointments: Appointment[] | undefined
  appointmentsOrdering?: Ordering
  date: Date
  isTutor?: boolean
  onDateClick: (date: Date) => void
}): React.ReactElement {
  const [showAllAppointments, setShowAllAppointments] = useState(false)

  const timezone = getBrowserTimezone()
  const datesWithAppointments = getDatesWithAppointments(appointments, timezone)
  const appointmentsForDate = getAppointmentsForDate(appointments, date)
  const appointmentsFromDate = getAppointmentsFromDate(appointments, date)

  const handleOnDateClick = (newDate: Date): void => {
    onDateClick(newDate)
    setShowAllAppointments(false)
  }

  const handleOnShowAllAppointmentsClick = (): void => {
    onDateClick(new Date())
    setShowAllAppointments(true)
  }

  return (
    <div className="w-max max-w-xs space-y-4 flex flex-col rounded shadow-large bg-white">
      <Calendar date={date} onDateClick={handleOnDateClick} sessionDays={datesWithAppointments} />
      <div className="w-full h-px bg-gray-light" />
      <Appointments
        appointments={showAllAppointments ? appointmentsFromDate : appointmentsForDate}
        appointmentsOrdering={appointmentsOrdering}
        isTutor={isTutor}
        onShowAllAppointmentsClick={handleOnShowAllAppointmentsClick}
        selectedDate={date}
        showAllAppointments={showAllAppointments}
      />
    </div>
  )
}
